import { render, staticRenderFns } from "./ysqxsbj.vue?vue&type=template&id=4909d6ae"
import script from "./ysqxsbj.vue?vue&type=script&lang=js"
export * from "./ysqxsbj.vue?vue&type=script&lang=js"
import style0 from "./ysqxsbj.vue?vue&type=style&index=0&id=4909d6ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports